<script>
import Vue from "vue";
import _ from "lodash";
import Component from "vue-class-component";
import TfmMap from "@/components/TfmMap";

@Component
class BigMap extends TfmMap {
	mounted() {
		// console.debug("Map Component Mounted");
		this.resizeMap.bind(this);
		Vue.nextTick(() => {
			window.addEventListener("resize", this.resizeMap);
			this.resizeMap();
		});
	}

	beforeDestroy() {
		window.removeEventListener("resize", this.resizeMap);
	}

	resizeMap() {
		window._bm = this;
		var m = this.$refs.map;
		var map = m.$el;
		window._map_el = map;
		var mo = m.mapObject;
		if (typeof map === "undefined") return;
		// the map's parent is almost always the view container, whose parent contains the transition
		var bounds = map.parentElement.parentElement.getBoundingClientRect();
		var targetHeight = window.innerHeight - (bounds.top + window.pageYOffset);
		if (targetHeight < 1) {
			return;
		} // map doesn't fit in the current viewport somehow?
		map.style.height = targetHeight + "px";

		mo.flyTo(mo.getCenter(), mo.getZoom());

		mo.on("zoomanim", _.debounce(mo._onZoomTransitionEnd, 250));
		mo.invalidateSize();
	}
}

export default BigMap;
</script>

<style lang="stylus">
.leaflet-top {
	top: 4.5rem; /* breadcrumb height */
}

@media screen and (max-width: 600px) {
	.leaflet-top {
		top: 5.2rem; /* breadcrumb height */
	}
}
</style>
